import {Link, useParams, useSearchParams} from "react-router-dom";
import styles from "../../../pages/Admin/Admin.module.css";
import stylesad2 from "../../../pages/Admin/Admin2.module.css";
import stylesSwitch from "../../Button/BtnSwitch.module.css";
import React, {useEffect, useState} from "react";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {useUser} from "../../../contexts/UserContext";
import {useModal} from "../../../contexts/ModalContext";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowAltCircleDown, faArrowsToDot,
    faArrowUpFromGroundWater,
    faCalendar,
    faCalendarAlt, faCalendarCheck, faChair, faCircleArrowRight, faDolly, faDollyFlatbed,
    faEdit,
    faExternalLink, faLocation, faLocationDot, faPlus, faSpoon,
    faSquareCheck, faTableList, faWheelchairMove,
    faXmark
} from "@fortawesome/free-solid-svg-icons";
import {ReactComponent as AjouterIcone} from "../../../icons/ajouter.svg";
import {ImageIllustration} from "../../Image/ImageIllustration";
import TitleSecondary from "../../Title/TitleSecondary";
import {getUtilisateurRoleIcon, setPresenceParticipant} from "../../../services/UserService";
import {getSeanceStatusIcon, parseSeanceStatus} from "../../../services/SeanceService";
import BtnSwitch from "../../Button/BtnSwitch";
import ParticipationsTable from "../Participants/ParticipationsTable";
import TitleMain from "../../Title/TitleMain";
import {Formik} from "formik";
import TextAreaCustom from "../../Field/TextAreaCustom";
import BtnSave from "../../Button/BtnSave";
import Routing from "../../../services/routing";
import DateService from "../../../services/DateService";
import RenderComments from "../../Comment/RenderComment";

const SeanceVue = () => {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [data, setData] = useState();
    const [seance, setSeance] = useState();
    const [entreprise, setEntreprise] = useState();
    const [contrat, setContrat] = useState();
    const [activite, setActivite] = useState();
    const {updateDynamicBreadcrumb} = useBreadcrumb();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';
    const {entrepriseId, contratId, activiteId, seanceId} = useParams();
    const [smsCharCount, setSmsCharCount] = useState(0);

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const getSeance = async () => {
        try {
            const response = await AxiosConfig.get(`/admin/entreprises/${entrepriseId}/contrats/${contratId}/activites/${activiteId}/seances/${seanceId}`);

            setContrat(response.data.myContrat);
            setEntreprise(response.data.myEntreprise);
            setActivite(response.data.myActivite);
            setSeance(response.data.mySeance);
            setData(response.data.mySeance);
        } catch (error) {
            console.error('error', error);
        }
    }

    const putActifOpenModal = (row) => {
        const text = data.actif ? "Supprimer" : "Restaurer";
        showModal('confirm', {
            message: `${text} cette séance ?`,
            onConfirm: async () => {
                try {
                    const response = await AxiosConfig.post(`/admin/entreprises/${entreprise.id}/contrats/${contrat.id}/activites/${activite.id}/seances/${seance.id}/actif`, {actif: !seance.actif});
                    if (response.data.success) {
                        setTimeout(async () => {
                            getSeance();
                        }, 500);
                    }
                    handleSuccess("Mis à jour effectuée avec succès");
                } catch (error) {
                    console.error('error', error);
                    handleError();
                }
            }
        });
    }

    const putAbsenceActifOpenModal = (absence) => {
        const text = absence.actif ? "Rejeter" : "Valider";
        showModal('confirm', {
            message: `${text} cette absence ?`,
            onConfirm: async () => {
                try {
                    const response = await AxiosConfig.post(`/admin/entreprises/${entreprise.id}/contrats/${contrat.id}/activites/${activite.id}/seances/${seance.id}/absences/${absence.id}/actif`, {actif: !absence.actif});
                    if (response.data.success) {
                        setTimeout(async () => {
                            getSeance();
                        }, 500);
                    }
                    handleSuccess("Statut modifié avec succès");
                } catch (error) {
                    console.error('error', error);
                    handleError();
                }
            }
        });
    }

    const putParticipationActifOpenModal = (participation) => {
        const text = participation.actif ? "supprimer" : "restaurer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} cette participation ?`,
            onConfirm: async () => {
                try {
                    const response = await AxiosConfig.post(`/admin/entreprises/${entreprise.id}/contrats/${contrat.id}/activites/${activite.id}/seances/${seance.id}/participations/${participation.id}/actif`, {actif: !participation.actif});
                    if (response.data.success) {
                        setTimeout(async () => {
                            getSeance();
                        }, 500);
                    }
                    handleSuccess("Statut modifié avec succès");
                } catch (error) {
                    console.error('error', error);
                    handleError();
                }
            }
        });
    }

    const putParticipationPresenceOpenModal = (participantId, seanceId, value) => {
        const text = value ? "l'absence" : "la présence";
        showModal('confirm', {
            message: `Confirmer ${text} cet utilisateur pour cette séance ?`,
            onConfirm: async () => {
                try {
                    const data = await setPresenceParticipant(seanceId, participantId, !value);
                    if (data.success) {
                        setTimeout(async () => {
                            getSeance();
                        }, 500);
                        handleSuccess("Participation mise à jour avec succès");
                    } else {
                        handleError(data.msg);
                    }
                } catch (error) {
                    console.error('error', error);
                    handleError();
                }
            }
        });
    }

    const putParticipationShowRatingPopupOpenModal = (participation) => {
        const text = participation.show_modal_rating ? "supprimer" : "restaurer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} la popup d'évaluation de cette participation pour cet utilisateur ?`,
            onConfirm: async () => {
                try {
                    const response = await AxiosConfig.post(`/admin/entreprises/${entreprise.id}/contrats/${contrat.id}/activites/${activite.id}/seances/${seance.id}/participations/${participation.id}/show_modal_rating`, {show_modal_rating: !participation.show_modal_rating});
                    if (response.data.success) {
                        setTimeout(async () => {
                            getSeance();
                        }, 500);
                    }
                    handleSuccess("Statut modifié avec succès");
                } catch (error) {
                    console.error('error', error);
                    handleError();
                }
            }
        });
    }

    const handleSubmitParticipationStatus = async (values, {setSubmitting}) => {
        try {
            const response = await AxiosConfig.post(`/admin/participations/${values.id}/status`, values);

            if (response.data.success) {
                handleSuccess(response.data.message);
            } else {
                console.error('error', response.data);
                handleError("Erreur : " + response.data.message);
            }
        } catch (error) {
            console.error('error', error);
            handleError();
        }
    };

    useEffect(() => {
        getSeance();
    }, [seanceId]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({entreprise, contrat, activite, seance}));
    }, [entreprise, contrat, activite, seance]);

    return (
        <>
            <div style={{display: "flex", flexDirection: "row"}}>
                <div className="content">
                    {data && !data?.actif && <span style={{
                        backgroundColor: "#ec4747",
                        color: "#fff",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        padding: "6px 14px"
                    }}>SÉANCE SUPPRIMÉE</span>}

                    <TitleMain text={seance?.titre ?? "Chargement ..."}/>
                    <div className={styles.navLink}>
                        <Link to={Routing.generate({route: Routing.routes.seance, params: {id: seanceId}})}>
                            <FontAwesomeIcon icon={faExternalLink}/>
                            Voir la séance dans l'appli
                        </Link>
                    </div>

                    <div className={styles.viewBloc}>
                        <TitleSecondary text={"Détail de la séance "}/>
                        <div className={styles.headerBtnsVue}>
                            <button onClick={putActifOpenModal}>{data?.actif ? <><FontAwesomeIcon
                                icon={faXmark}/>Supprimer</> : <><FontAwesomeIcon
                                icon={faSquareCheck}/>Restaurer</>}</button>
                            <Link to={Routing.routes.adminCreation}><FontAwesomeIcon icon={faEdit}/>Modifier</Link>
                        </div>

                        <div>
                            <p>
                                {getSeanceStatusIcon(data?.status)}
                                <span style={{marginLeft: "4px"}}>{parseSeanceStatus(data?.status)} : </span>
                                <span style={{marginLeft: "4px"}}>{data?.status_info}</span>
                            </p>

                            <p>
                                <FontAwesomeIcon icon={faTableList}/> <Link
                                to={Routing.generate({
                                    route: Routing.routes.adminActivite,
                                    params: {entrepriseId, contratId, activiteId}
                                })}>{activite?.type.nom}</Link>
                            </p>

                            <p>
                                <FontAwesomeIcon icon={faCalendarAlt}/>
                                <span
                                    style={{marginLeft: "4px"}}>{DateService.formatDateWithDuration(data?.date, data?.duree)}</span>
                            </p>

                            {data?.periode_inscription &&
                                <p>
                                    <FontAwesomeIcon icon={faCalendarCheck}/><span style={{marginLeft: "4px"}}>Début des inscriptions :</span>
                                    <span
                                        style={{marginLeft: "4px"}}> {DateService.formatDateFull(data?.periode_inscription)}</span>
                                </p>
                            }

                            <p>
                                <FontAwesomeIcon icon={faLocationDot}/>
                                <span
                                    style={{marginLeft: "4px"}}>{data?.lieu.nom}, {data?.lieu.adresse} - {data?.lieu.ville}, {data?.lieu.code_postal}</span>
                            </p>

                            <p>
                                {getUtilisateurRoleIcon("ROLE_COACH")}
                                <span style={{marginLeft: "4px"}}>
                                <Link to={data?.coach.id && Routing.generate({
                                    route: Routing.routes.adminUtilisateur,
                                    params: {utilisateurId: data?.coach.id}
                                })}>
                                    {data?.coach.prenom} {data?.coach.nom}
                                </Link>
                            </span>
                            </p>
                            <p>
                                <FontAwesomeIcon icon={faChair}/> {data?.placesReservees} / {data?.participantsMax}
                            </p>
                        </div>
                    </div>

                    <div className={styles.viewBloc}>
                        <TitleSecondary text={"Absences coach"}/>
                        {data?.absences && data.absences.length > 0 ? (
                            <ul className={styles.absences}>
                                {data?.absences?.map((absence, index) => {
                                    return (
                                        <li key={index}>
                                            <span>{DateService.formatDate(absence?.created_at)}</span>
                                            <Link to={Routing.generate({
                                                route: Routing.routes.adminUtilisateur,
                                                params: {utilisateurId: absence?.coach.id}
                                            })}>
                                                {absence?.coach.prenom} {absence?.coach.nom}
                                            </Link>

                                            <div style={{display: "flex", flexDirection: "row"}}>
                                                <BtnSwitch active={absence?.actif}
                                                           onToggle={() => putAbsenceActifOpenModal(absence)}
                                                           activeLabel={"Validée"}
                                                           inactiveLabel={"En attente"}
                                                           classNames={`${stylesSwitch.sliderCard} ${stylesSwitch.sliderCardDark}`}/>
                                            </div>
                                        </li>)
                                })}
                            </ul>
                        ) : <p>Aucune absence</p>}

                        <div className={styles.navLink}>
                            <button className={"btn"} style={{
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "nowrap",
                                maxWidth: "200px",
                                fontSize: "0.8em",
                                padding: "px"
                            }}
                                    onClick={async () => {
                                        showModal('confirm', {
                                            message: `Voulez-vous vraiment ajouter une absence coach pour cette séance ? ${data.coach.prenom} ${data.coach.nom} - ${DateService.formatDateFull(data?.date)} `,
                                            onConfirm: async () => {
                                                const response = await AxiosConfig.post(`/admin/entreprises/${entrepriseId}/contrats/${contratId}/activites/${activiteId}/seances/${seanceId}/absences/creation`);
                                                setTimeout(async () => {
                                                    if (response.data.success) {
                                                        handleSuccess("Absence ajoutée avec succès", 5000);
                                                        getSeance();
                                                    } else {
                                                        handleError(response.data.error ?? response.data.message, 5000);
                                                    }
                                                }, 500);

                                                hideModal();
                                            }
                                        });
                                    }}>
                                <AjouterIcone/>
                                Ajouter une absence coach
                            </button>
                        </div>
                    </div>

                    <div className={styles.viewBloc} style={{display: "none"}}>
                        <TitleSecondary text="Envoyer un SMS aux participants"/>

                        <Formik
                            initialValues={{sender: user.id, sms: ''}}
                            onSubmit={async (values, {setSubmitting}) => {
                                const response = await AxiosConfig.post(`/seances/seance/${seance.id}/send_sms`, values);
                                if (response.data.success) {
                                    handleSuccess(response.data.message);
                                } else {
                                    handleError(response.data.message);
                                }

                                setSubmitting(false);
                            }}
                        >
                            {({handleSubmit, isSubmitting, setFieldValue}) => (
                                <form onSubmit={handleSubmit} className={`spaceBottom ${styles.form}`}
                                      style={{
                                          textAlign: "left",
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "center",
                                          alignItems: "center"
                                      }}>

                                    <div style={{maxWidth: "400px"}}>
                                        <TextAreaCustom
                                            id={"sms"}
                                            name={"sms"}
                                            label={""}
                                            placeholder={"Message ... (100 caractères max)"}
                                            onChange={(e) => {
                                                setSmsCharCount(e.target.value.length);
                                                setFieldValue('sms', e.target.value)
                                            }}
                                        />
                                        <span style={{
                                            fontSize: "var(--fs-secondary)",
                                            marginBottom: "4px"
                                        }}>{smsCharCount} / 100 caractères </span>

                                        <BtnSave text={"Envoyer"}/>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>


                <div style={{ margin: "25px"}}>
                    <RenderComments urlGetComments={`/admin/seances/${seanceId}/comments`} urlAddComment={`/admin/seances/${seanceId}/add_comment`} data={data} />
                </div>
            </div>

            <div className={"content_tab"}>
                <TitleSecondary text={"Participations"}/>
                <div className={styles.navLink}>
                    <Link to={Routing.generate({
                        route: Routing.routes.adminSeanceParticipations,
                        params: {entrepriseId, contratId, activiteId, seanceId}
                    })}>
                        <FontAwesomeIcon icon={faExternalLink}/>
                        Accéder aux participations
                    </Link>

                    <Link to={Routing.generate({
                        route: Routing.routes.adminSeanceParticipations,
                        params: {entrepriseId, contratId, activiteId, seanceId},
                        queryParams: {mode: 'creation'}
                    })}>
                        <AjouterIcone/>
                        Ajouter une participation
                    </Link>

                </div>

                {data?.participations && data?.participations.length > 0 && <ParticipationsTable
                    entreprise={entreprise}
                    contrat={contrat}
                    activite={activite}
                    seance={seance}
                    participations={data?.participations}
                    putActifOpenModal={putParticipationActifOpenModal}
                    putPresence={putParticipationPresenceOpenModal}
                    putShowModalRatingOpenModal={putParticipationShowRatingPopupOpenModal}
                    handleSubmitParticipationStatus={handleSubmitParticipationStatus}
                />}
            </div>
        </>
    )
}

export default SeanceVue;